import React from 'react';
import { DeliverableTemplate } from '../../types/deliverable';
import { TemplateCard } from './TemplateCard';
import { FileText } from 'lucide-react';

interface TemplateListProps {
  templates: DeliverableTemplate[];
  isLoading: boolean;
  onView: (template: DeliverableTemplate) => void;
  onEdit: (template: DeliverableTemplate) => void;
  onApply: (template: DeliverableTemplate) => void;
  onDelete: (template: DeliverableTemplate) => void;
  canEdit: boolean;
}

export const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  isLoading,
  onView,
  onEdit,
  onApply,
  onDelete,
  canEdit,
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg shadow-md p-6 border border-gray-200 animate-pulse"
          >
            <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div className="h-20 bg-gray-200 rounded mb-4"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 bg-white rounded-lg border-2 border-dashed border-gray-300">
        <FileText className="w-16 h-16 text-gray-400 mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          No templates yet
        </h3>
        <p className="text-gray-600 text-center max-w-md">
          Get started by creating your first deliverable template. Templates help
          you standardize common deliverables across your organization.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          onView={onView}
          onEdit={onEdit}
          onApply={onApply}
          onDelete={onDelete}
          canEdit={canEdit}
        />
      ))}
    </div>
  );
};
